module.exports = __webpack_public_path__ + "img/avatar1.84ad6793.jpg";